import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, message } from 'antd';
import axiosInstance from '../../utils/axios';


const GenreModal = ({ open, setOpen, genre, setGenre, selectedId}) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [selectedItem, setSelectedItem] = useState(null);

	useEffect(() => {
		if (open) {
			if (selectedId !== null) {
				const item = genre.find(p => p.id === selectedId);
				setSelectedItem(item);

				if (item) {
					form.setFieldsValue({ name: item.name, alias: item.alias });
				}

			} else {
				setSelectedItem(null);
				form.resetFields();
			}
		}
	}, [open, selectedId, genre]);

	const handleCancel = () => {
    setOpen(false);
    form.resetFields();
    setSelectedItem(null);
  };

	const handleFinish = async (values) => {
    setLoading(true);

    try {
      let response;
      if (selectedItem) {
        response = await axiosInstance.patch(`core/genre/${selectedItem.id}/`, values);
        setGenre(prev => prev.map(p => (p.id === selectedItem.id ? response.data : p)));
        message.success("Genre updated successfully!");

      } else {
        response = await axiosInstance.post(`core/genre/`, values);
        setGenre(prev => [...prev, response.data]);
        message.success("Genre added successfully!");
      }

      form.resetFields();
      setOpen(false);
    } catch (error) {
      if(error.response && error.response.data &&  error.response.data)
        message.error(error.response.data.name[0]);
      else
        message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

	return (
		<Modal
			title={selectedItem ? "Edit Genre" : "Add new Genre"}
      open={open}
      onCancel={handleCancel}
      destroyOnClose
      okButtonProps={{
        autoFocus: true,
        htmlType: 'submit',
        loading: loading,
        disabled: loading,
      }}
      onOk={() => form.submit()}
		>
 			<Form
        layout="vertical"
        form={form}
        name="language_form"
        onFinish={handleFinish}
      >
        <Form.Item
          label="Genre"
          name="name"
          rules={[{ required: true, message: 'Please enter a genre' }]}
        >
          <Input placeholder="Eg: Action" />
        </Form.Item>
      </Form>
		</Modal>
	)
}

export default GenreModal